<template>
<div class="home_add">
    <tooltip v-if="!ext">
        <template v-slot:item>
            <div :class="buttonclass">
                <i class="fa-solid fa-plus"></i>
            </div>
        </template>

        <template v-slot:content="i">
            <listmenu :items="menu" :close="i.close" />
        </template>

    </tooltip>

    <div class="ext" v-else>
        <button class="button " :class="(i && !item.style ? 'black' : '') + ' ' + (item.style || '') + ' ' + (small ? 'small' : '')" v-for="(item, i) in menu" @click="item.action">
            <i v-if="item.icon" :class="item.icon"/>
            <span v-if="item.text">{{$t(item.text)}}</span>
            <img :src="require('@/assets/' + item.svg)" v-if="item.svg"/>
        </button>
    </div>
</div>
</template>

<style scoped lang="sass">
.ext
    display: flex
    align-items: center
    flex-wrap: wrap
    white-space: nowrap
    
    button
        display: flex
        align-items: center
        margin-right: $r
        justify-content: center

        span
            margin-bottom: 2px

        &.aibutton
            background: transparent
            border-color: transparent

        img
            height: 18px
            margin-left: 6px

        i
            margin-top: 2px
            font-size: 0.8em
            margin-right: $r
    
</style>

<script>
import {
    mapState
} from 'vuex';

export default {
    name: 'home_add',
    props: {
        ext : Boolean,
        buttonclass: {
            type: String,
            default: 'buttonpanel'
        },

        success : Boolean,
        small : Boolean
    },
    computed: mapState({
        auth: state => state.auth,

        mobileview : state => state.mobileview,
        menu: function () {

            var menu = []

            return this.core.user.extendByFeaturesMenu(menu)

        }

    }),

    methods: {
       

    },
}
</script>
